import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../index';

type UserState = {
  displayName: string;
  email: string;
};

const initialState: UserState = {
  displayName: '',
  email: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (_state, action: PayloadAction<UserState>) => action.payload,
  },
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;

export const selectUser = (state: RootState): UserState => state.user;
